import React from 'react'
import Layout from '../../components/Layout/Layout'
import { Link } from 'react-router-dom'

const UserDashboard = () => {
  return (
    <Layout title={'User Dashboard'}>
      <div className='container'>
        <div className='row'>
          <div className='col-12 col-md-4 mt-4 mb-2 gx-3 gy-3'>
            <div className='card'>
              <Link
                to='/user/pre-order/books/list'
                className='btn btn-outline-success'
                style={{ fontSize: '20px' }}
              >
                Pre-Order
              </Link>
            </div>
          </div>

          <div className='col-12 col-md-4 mt-4 mb-2 gx-3 gy-3'>
            <div className='card'>
              <Link
                to='/user/packing-list'
                className='btn btn-outline-success'
                style={{ fontSize: '20px' }}
              >
                Packing List
              </Link>
            </div>
          </div>
          <div className='col-12 col-md-4 mt-4 mb-2 gx-3 gy-3'>
            <div className='card'>
              <Link
                to='/user/stock-check'
                className='btn btn-outline-success'
                style={{ fontSize: '20px' }}
              >
                Stock Check
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default UserDashboard
